// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import StaffService from '@services/staff'

export const getAllStaff = createAsyncThunk('staff/getAllStaff', async (params, { rejectWithValue }) => {
  try {
    const response = await StaffService.getAllStaff(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getStaffById = createAsyncThunk('staff/getStaffById', async (id) => {
  const response = await StaffService.getStaffById(id)
  return response
})

export const addStaff = createAsyncThunk('staff/addStaff', async (staff, { rejectWithValue }) => {
  try {
    const response = await StaffService.addStaff(staff)
    return response
  } catch (err) {
    // console.log(err)
    return rejectWithValue(err.response.data)
  }
})

export const updateStaff = createAsyncThunk('staff/updateStaff', async (staff, { rejectWithValue }) => {
  try {
    const response = await StaffService.updateStaff(staff)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const deleteStaff = createAsyncThunk('staff/deleteStaff', async (id, { dispatch, getState }) => {
  await StaffService.deleteStaff(id)
  await dispatch(getAllStaff(getState()?.staffInformations.params))
  return id
})

export const staffSlice = createSlice({
  name: 'staff',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualStaff: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllStaff.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getStaffById.fulfilled, (state, action) => {
        state.individualStaff = action.payload
        state.loading = false
      })
      .addCase(getStaffById.pending, (state, action) => {
        state.individualStaff = action.payload
        state.loading = true
      })
      .addCase(getStaffById.rejected, (state, action) => {
        state.individualStaff = action.payload
        state.loading = false
      })
  }
})

export default staffSlice.reducer
